export default "__VITE_ASSET__B2CK8P0R__"